import { Component, OnInit } from '@angular/core';
import { ParentsService } from 'src/app/shared/services/parents.service';
import { StudentsService } from 'src/app/shared/services/students.service';
import { ProfileService } from "src/app/shared/services/profile.service";
import { IStudentsDeviceCheckedOut, IStudentsDeviceCheckedOutHistory } from './model/IStudentsDeviceCheckedOut';
import { ToastrService } from 'ngx-toastr';
import { IStudentResume } from '../../student-list-widget/models/IStudentResume';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-student-devices-checked-out',
  templateUrl: './student-devices-checked-out.component.html',
  styleUrls: ['./student-devices-checked-out.component.scss']
})

export class StudentDevicesCheckedOutComponent implements OnInit {

  studentDevicesCheckedOut: IStudentsDeviceCheckedOut[] = [];
  studentDevicesCheckedOutHistory: IStudentsDeviceCheckedOutHistory[] = [];
  selectedStudentDevicesCheckedOut: IStudentsDeviceCheckedOut[] = [];
  finalStudentDevicesCheckedOut: IStudentsDeviceCheckedOut[] = [];
  studentsList: IStudentResume[] = [];
  devicesCheckedOutCheckboxGroups: any = [];
  additionalDevices: any[] = [];
  deviceTypeAndManufacturer = [];
  deviceTypeList: string[] = [];
  confirmAuthority: boolean = false;
  agreePolicy: boolean = false;
  parentName: string = '';
  phoneNumber: string = '';
  todayDate: string = '';
  showParentNameValidation = false;
  showParentPhoneValidation = false;
  showConfirmAuthorityValidation = true;
  showAgreePolicyValidation = true;
  currentParentId: string = '';
  currentParentName: string = '';
  currentParentEmail: string = '';

  constructor(
    private parentService: ParentsService,
    private toastr: ToastrService,
    private studentService: StudentsService,
    private profileService: ProfileService
  ) { }

  ngOnInit(): void {
    const profile = this.profileService.profile;
    this.currentParentId = profile.id;
    this.currentParentName = profile.firstName + " " + profile.lastName;
    this.currentParentEmail = profile.email;
    this.getStudentsDevicesCheckedOut();
    this.getStudentsListByParent();
    this.getStudentsDevicesCheckedOutHistory();
    this.addAdditionalDevice(true);
    this.todayDate = this.getTodayDate();
  }

  getTodayDate(): string {
    const date = new Date();
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getStudentsListByParent(): void {
    this.parentService.getStudentsByParent().subscribe(
      (data) => {      
        this.studentsList = data.filter(a=>a.enrollmentStatus==='Y');
      },
      (error) => {
        this.toastr.error(`Can't load Students - error Occured - ${error}`);
      }
    );
  }

  getStudentsDevicesCheckedOut(): void {
    this.parentService.getStudentsDevicesCheckedOut().subscribe(
      (data) => {
        this.studentDevicesCheckedOut = data;
      },
      (error) => {
        this.toastr.error(`Can't load Students - error Occured - ${error}`);
      }
    );
  }

  getStudentsDevicesCheckedOutHistory(): void {
    this.parentService.getStudentsDevicesCheckedOutHistory().subscribe(
      (data) => {
        this.studentDevicesCheckedOutHistory = data;
      },
      (error) => {
        this.toastr.error(`Can't load Students - error Occured - ${error}`);
      }
    );
  }

  getDevicesData() {
    this.parentService.getFeatureConfigurationByName("deviceType_and_manufacturer").subscribe(
      (data) => {
        const parsedData = JSON.parse(data.value);
        const devicesObject = parsedData[0];

        this.deviceTypeAndManufacturer = Object.entries(devicesObject).map(
          ([deviceType, manufacturers]) => ({
            device_type: deviceType,
            manufacturers: manufacturers as string[]
          })
        );
      },
      (error) => {
        this.toastr.error(`Can't load Students - error Occured - ${error}`);
      }
    );
  }

  onStudentChange(event: any, index: number): void {
    const selectedStudentId = event.target.value;
    this.studentService.getStudentSchoolInfo(selectedStudentId).subscribe(
      (data) => {
        this.additionalDevices[index].school_Name = data.schoolName;
        this.additionalDevices[index].selected_student_Name = data.firstName + " " + data.lastName;
        this.additionalDevices[index].selected_student_Id = selectedStudentId;
        this.additionalDevices[index].cost_Center = data.costCenterCode;
      },
      (error) => {
        this.toastr.error(`Can't load Students - error Occured - ${error}`);
      }
    );
  }

  addAdditionalDevice(isLoad): void {
    if (this.validationRows(isLoad)) {
      this.additionalDevices.push({
        student_Id: '',
        selected_student_Id: '',
        student_Name: '',
        school_Name: '',
        selected_student_Name: '',
        asset_Barcode: '',
        serial_Number: '',
        device_status: 'not listed',
        showDeviceIdError: false,
        cost_Center: ''
      });
    }
  }

  clearDeviceIdError(device: any): void {
    if (device.asset_Barcode || device.serial_Number) {
      device.showDeviceIdError = false;
    }
  }

  removeAdditionalDevice(index: number): void {
    this.additionalDevices.splice(index, 1);
  }

  onCheckboxChange(event: any, row: IStudentsDeviceCheckedOut): void {
    if (event.checked) {
      row.device_status = 'lost/stolen';
      this.selectedStudentDevicesCheckedOut.push(row);
    }
    else {
      const index = this.selectedStudentDevicesCheckedOut.indexOf(row);
      if (index > -1) {
        this.selectedStudentDevicesCheckedOut.splice(index, 1);
      }
    }
  }

  onAlphabetsOnly(event: any) {
    this.showParentNameValidation = true;
    this.showParentPhoneValidation = true;
    const charCode = event.charCode;
    if (
      (charCode >= 65 && charCode <= 90) ||   // A-Z
      (charCode >= 97 && charCode <= 122) ||  // a-z
      charCode === 32                         // space
    ) {
      return true;
    }

    return false;
  }

  onPhoneNumberChange(value: string, field: string) {
    const x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

    if (x) {
      value = !x[2]
        ? x[1]
        : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    }

    this[field] = value;
  }

  onSubmit(form: NgForm): void {
    this.finalStudentDevicesCheckedOut = [];

    if (this.selectedStudentDevicesCheckedOut.length > 0) {
      this.selectedStudentDevicesCheckedOut.forEach(device => {
        this.finalStudentDevicesCheckedOut.push(device);
      });
    }

    if (this.additionalDevices.length > 0) {

      if (!this.validationRows(false)) {
        return;
      }
      this.additionalDevices.forEach(device => {

        const selectedStudent = device.selected_student_Id ? device.selected_student_Id.trim() : '';
        const assetBarcode = device.asset_Barcode ? device.asset_Barcode.trim() : '';
        const serialNumber = device.serial_Number ? device.serial_Number.trim() : '';

        if (selectedStudent !== '' && (assetBarcode !== '' || serialNumber !== '')) {
          const mappedDevice = {
            student_Id: device.selected_student_Id,
            student_Name: device.selected_student_Name,
            school_Name: device.school_Name,
            asset_Barcode: device.asset_Barcode ? device.asset_Barcode.trim() : '',
            serial_Number: device.serial_Number ? device.serial_Number.trim() : '',
            cost_Center: device.cost_Center,
            model: null,
            device_Type: null,
            manufacturer: null,
            imei: null,
            lte_status: null,
            device_status: 'not listed',
            checkout_Date: this.todayDate,
            report_Date: this.todayDate,
            selected: false
          };
          this.finalStudentDevicesCheckedOut.push(mappedDevice);
        }
      });
    }

    if (this.finalStudentDevicesCheckedOut.length > 0) {
      let requestData = {
        parent_id: this.currentParentId,
        parent_Name: this.currentParentName,
        parent_signature: this.parentName,
        signature_date: this.todayDate,
        phone_Number: this.phoneNumber,
        parent_Email: this.currentParentEmail,
        isConfirmAuthority: this.confirmAuthority,
        isAgreePolicy: this.agreePolicy,
        mdlDevicesCheckedOut: this.finalStudentDevicesCheckedOut
      };
      this.parentService.saveStudentsDevicesCheckedOut(requestData).subscribe({
        next: (res) => {
          this.toastr.clear();
          this.toastr.success("Your request has been submitted successfully.", 'Success');
          this.clearItems();
        },
        error: () => {
          this.toastr.error("Failed to submit your request.", "Error");
        }
      });
    }
    else {
      this.toastr.warning("This form is only for reporting lost/stolen devices or devices not listed in the records. If there is no issue to report, you do not need to submit this form.");
      return;
    }
  }

  validationRows(onload: boolean) {
    var isValidationPassed = true;

    if (onload) {
      isValidationPassed = true;
    }
    else {
      if (this.additionalDevices.length > 0) {
        this.additionalDevices.forEach(device => {
          device.showDeviceIdError = false;

          const selectedStudent = device.selected_student_Id ? device.selected_student_Id.trim() : '';
          const assetBarcode = device.asset_Barcode ? device.asset_Barcode.trim() : '';
          const serialNumber = device.serial_Number ? device.serial_Number.trim() : '';

          if (this.selectedStudentDevicesCheckedOut.length === 0) {
            if (selectedStudent === '') {
              device.showDeviceIdError = true;
              isValidationPassed = false;
            }
            if (assetBarcode === '' && serialNumber === '') {
              this.toastr.warning("If you do not have any LAUSD devices, please delete the row. If you do, enter the Student Name and Serial Number or Asset Barcode so it can be tracked.");
              device.showDeviceIdError = true;
              isValidationPassed = false;
            }
          }
          else {
            if (selectedStudent !== '') {
              if (assetBarcode === '' && serialNumber === '') {
                this.toastr.warning("If you do not have any LAUSD devices, please delete the row. If you do, Serial Number or Asset Barcode so it can be tracked.");
                device.showDeviceIdError = true;
                isValidationPassed = false;
              }
            }
          }
        });
        //Check Duplicates rows 
        if (isValidationPassed && this.additionalDevices.length > 0) {
          const keys = this.additionalDevices.map(d => JSON.stringify(d));
          const hasDuplicates = new Set(keys).size !== keys.length;
          if (hasDuplicates) {
            this.toastr.warning("Duplicate record are exists");
            isValidationPassed = false;
          }
        }
      }
    }
    return isValidationPassed;
  }

  clearItems() {
    this.studentDevicesCheckedOut.forEach(d => d.selected = false);
    this.selectedStudentDevicesCheckedOut = [];
    this.finalStudentDevicesCheckedOut = [];
    this.additionalDevices = [];
    this.confirmAuthority = false;
    this.agreePolicy = false;
    this.parentName = '';
    this.showParentNameValidation = false;
    this.phoneNumber = '';
    this.showParentPhoneValidation = false;
    this.showConfirmAuthorityValidation = false;
    this.showAgreePolicyValidation = false;
    this.addAdditionalDevice(true);
    this.getStudentsDevicesCheckedOutHistory();
  }
  
  convertUTCtoLocalDatetime(utcDate:any) {
    const localDate =  new Date(utcDate + 'Z');
    return localDate;
  }
  
}